class LocalizationException {
  constructor(message) {
    this.message = message;
    this.name = 'LocalizationException';
  }
}

export default LocalizationException;
